// src/pages/CampaignFlow/components/FlowStepper.jsx
import React from 'react';
import {
  UserIcon,
  PaintBrushIcon,
  RocketLaunchIcon,
  ChartBarIcon,
  CheckIcon,
} from '@heroicons/react/24/outline';

const STEPS = [
  { id: 'profile',  label: 'Perfil',   Icon: UserIcon },
  { id: 'creation', label: 'Criação',  Icon: PaintBrushIcon },
  { id: 'boost',    label: 'Turbinar', Icon: RocketLaunchIcon },
  { id: 'sales',    label: 'Vendas',   Icon: ChartBarIcon },
];

const STEP_INDEX = { profile: 0, creation: 1, boost: 2, sales: 3 };

export default function FlowStepper({ currentStep }) {
  const currentIdx = STEP_INDEX[currentStep] ?? 0;

  return (
    <div className="cf-stepper">
      {STEPS.map((step, idx) => {
        const done    = idx < currentIdx;
        const active  = idx === currentIdx;
        return (
          <React.Fragment key={step.id}>
            <div className={`cf-step ${done ? 'cf-step--done' : ''} ${active ? 'cf-step--active' : ''}`}>
              <div className="cf-step__bubble">
                {done
                  ? <CheckIcon style={{ width: 18, height: 18 }} />
                  : <step.Icon style={{ width: 18, height: 18 }} />}
              </div>
              <span className="cf-step__label">{step.label}</span>
            </div>
            {idx < STEPS.length - 1 && (
              <div className={`cf-step-connector ${done ? 'cf-step-connector--done' : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
